import { useState, useRef } from "react";
import  ShareDownloadsModal from '@/components/share_downloads_modal.js';
export default function BulkAssetLinks({product, config })  {
  const [showDownload, setShowDownload] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const shareLinkEnabled =  config?.enable_asset_multiple_link_copying_modal
  const downloadLinkEnabled =  config?.enable_asset_multiple_link_download_modal

  return (
    <> 
    <div className="lexcms-product-share-section">
      {shareLinkEnabled &&
      <div
        className="lexcms-product-share"
        onClick={() => setShowShare(true)}
      >
        <div className="lexcms-product-share-icon"></div>
        <span className="lexcms-product-share-text">Share Links</span>
      </div>
      }
      {downloadLinkEnabled &&
      <div
        className="lexcms-product-downloads"
        onClick={() => setShowDownload(true)}
      >
        <div className="lexcms-product-downloads-icon"></div>
        <span className="lexcms-product-downloads-text">Download</span>
      </div>
      }
    </div>
      {showShare  && (
        <ShareDownloadsModal product={product } setShowShare={setShowShare} showShare={showShare } />
      )}
      {showDownload  && (
        <ShareDownloadsModal product={product }  setShowShare={setShowDownload} showShare={showDownload } type='download' />
      )}

    </>
  )

}
